import { FC } from 'react';
import { Box, Tooltip, TooltipProps } from '@chakra-ui/react';

import {
  FileBrowserFileFragment,
  FileStatus,
  PiiStatus,
  VirusStatus,
} from '../../graphql/generated';

type Props = {
  file: FileBrowserFileFragment;
};

const DefaultTooltip: FC<TooltipProps> = ({ label, children }) => (
  <Tooltip hasArrow placement="top-end" label={label}>
    <Box display="inline-flex" data-testid="file-download-disabled">
      {children}
    </Box>
  </Tooltip>
);

export const DownloadDisabledTooltip: FC<Props> = ({ file, children }) => {
  if (file.status === FileStatus.AWAITING_UPLOAD) {
    return (
      <DefaultTooltip label="File cannot be downloaded as it is awaiting upload">
        {children}
      </DefaultTooltip>
    );
  }

  if (file.virusStatus === VirusStatus.SCANNING) {
    return (
      <DefaultTooltip label="File cannot be downloaded, virus scanning is in progress">
        {children}
      </DefaultTooltip>
    );
  }

  if (file.virusStatus === VirusStatus.QUARANTINED) {
    return (
      <DefaultTooltip label="File cannot be downloaded as it may contain a virus">
        {children}
      </DefaultTooltip>
    );
  }

  if (file.piiStatus === PiiStatus.SCANNING) {
    return (
      <DefaultTooltip label="File cannot be downloaded, PII scanning is in progress">
        {children}
      </DefaultTooltip>
    );
  }

  if (file.piiStatus === PiiStatus.AWAITING_APPROVAL) {
    return (
      <DefaultTooltip label="File cannot be downloaded, PII was detected and a manual approval is required">
        {children}
      </DefaultTooltip>
    );
  }

  if (file.status === FileStatus.ERROR) {
    return (
      <DefaultTooltip label="File cannot be downloaded, transformation errors were detected">
        {children}
      </DefaultTooltip>
    );
  }

  return <>{children}</>;
};
